(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-wella-slider]').forEach((slider) => {
      if (slider.dataset.wellaReady === 'true') return;
      const slides = [...slider.querySelectorAll('[data-wella-slide]')];
      if (!slides.length) return;
      slider.dataset.wellaReady = 'true';
      let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      let transitionVersion = 0;
      const dots = slider.querySelector('[data-wella-dots]');
      const prepareSlide = (slide) => {
        const image = slide?.querySelector('img');
        if (!image) return Promise.resolve();

        image.loading = 'eager';
        image.fetchPriority = 'high';

        const decode = () => {
          if (typeof image.decode !== 'function' || !image.naturalWidth) return Promise.resolve();
          return image.decode().catch(() => undefined);
        };

        if (image.complete) return decode();

        return new Promise((resolve) => {
          const finish = () => {
            image.removeEventListener('load', finish);
            image.removeEventListener('error', finish);
            decode().finally(resolve);
          };
          image.addEventListener('load', finish, { once: true });
          image.addEventListener('error', finish, { once: true });
        });
      };
      const show = (next) => {
        const nextIndex = (next + slides.length) % slides.length;
        const version = ++transitionVersion;
        prepareSlide(slides[nextIndex]).then(() => {
          if (version !== transitionVersion) return;
          index = nextIndex;
          slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
          dots?.querySelectorAll('button').forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        });
      };
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `wella-home__dot${i === index ? ' is-active' : ''}`;
        dot.setAttribute('aria-label', `الشريحة ${i + 1}`);
        dot.addEventListener('click', () => show(i));
        dots?.append(dot);
      });
      prepareSlide(slides[index]);
      slider.querySelector('[data-wella-prev]')?.addEventListener('click', () => show(index - 1));
      slider.querySelector('[data-wella-next]')?.addEventListener('click', () => show(index + 1));
      slider.addEventListener('wella:show-slide', (event) => {
        const selected = slides.indexOf(event.detail?.slide);
        if (selected < 0) return;
        clearInterval(slider.wellaAutoplayTimer);
        show(selected);
      });
      const startAutoplay = () => {
        if (slides.length > 1 && !slider.wellaAutoplayTimer) {
          slider.wellaAutoplayTimer = setInterval(() => show(index + 1), 8000);
        }
      };
      ['touchstart', 'scroll', 'pointerdown'].forEach((ev) => {
        window.addEventListener(ev, startAutoplay, { once: true, passive: true });
      });
      setTimeout(startAutoplay, 12000);
    });

    root.querySelectorAll('[data-wella-tabs]').forEach((tabsRoot) => {
      if (tabsRoot.dataset.wellaTabsReady === 'true') return;
      const tabs = [...tabsRoot.querySelectorAll('[data-wella-tab]')];
      const panels = [...tabsRoot.querySelectorAll('[data-wella-panel]')];
      if (!tabs.length || tabs.length !== panels.length) return;
      tabsRoot.dataset.wellaTabsReady = 'true';
      const initialIndex = Math.max(0, tabs.findIndex((tab) => tab.classList.contains('is-active')));

      const activate = (nextIndex) => {
        tabs.forEach((tab, index) => {
          const active = index === nextIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels[index].classList.toggle('is-active', active);
          panels[index].hidden = !active;
        });
      };

      activate(initialIndex);

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (index + direction + tabs.length) % tabs.length;
          activate(nextIndex);
          tabs[nextIndex].focus();
        });
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest?.('[data-wella-slide]');
    if (slide) slide.closest('[data-wella-slider]')?.dispatchEvent(new CustomEvent('wella:show-slide', { detail: { slide } }));
    const tab = event.target.matches?.('[data-wella-tab]') ? event.target : event.target.querySelector?.('[data-wella-tab]');
    tab?.click();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll?.('[data-wella-slider]').forEach((slider) => clearInterval(slider.wellaAutoplayTimer));
  });
})();
